import React from 'react';

export default function Loading() {
    return (
        <div className="fixed inset-0 bg-white/80 backdrop-blur-sm flex items-center 
      justify-center z-50">
            <div className="relative">
                <div className="w-16 h-16 border-4 border-primary border-t-transparent 
          rounded-full animate-spin"></div>
                <div className="mt-4 text-primary font-medium">Loading...</div>
            </div>
        </div>
    );
}